import { Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { addFilterToLocalStorage } from "../../common/EntitiesManagement";

export default function FilterBox({
  filterItemName,
  filterData,
  setFilterData,
  defaultFiltering,
  saveFilter,
}) {
  const [filterInformation, setFilterInformation] = useState(filterData);

  const handleRemoveButton = (itemToRemove) => {
    const index = filterInformation.indexOf(itemToRemove);
    if (index >= 0) {
      filterInformation.splice(index, 1);

      if (filterInformation.length === 0) {
        setFilterData(defaultFiltering);

        if (saveFilter) {
          addFilterToLocalStorage(filterItemName, defaultFiltering);
        }
      } else {
        setFilterData([...filterInformation]);

        if (saveFilter) {
          addFilterToLocalStorage(filterItemName, [...filterInformation]);
        }
      }
    }
  };

  useEffect(() => {
    setFilterInformation(filterData);
  }, [filterData]);

  return (
    <div>
      {filterInformation?.length > 0 ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {filterInformation?.length > 0 &&
            filterInformation.map((filter) => (
              <Chip
                sx={{
                  "& .MuiChip-deleteIcon": {
                    color: "white",
                  },
                  "& .MuiChip-deleteIcon:hover": {
                    color: "white",
                  },
                }}
                style={{
                  margin: "2px",
                  fontSize: "12px",
                  fontWeight: 400,
                  backgroundColor: "#10366E",
                  color: "white",
                  whiteSpace: "pre-wrap",
                }}
                key={filter.Name}
                label={`${filter.FriendlyName} ${
                  !!filter.Value ? `: ${filter.Value}` : ""
                }`}
                onDelete={() => {
                  handleRemoveButton(filter);
                }}
              />
            ))}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}
